import React, { Component, Fragment } from 'react'
import '../../styles/Popup.module.css'
import {
    Form,
    Select,
    Input,
    Button,
    Upload,
    Row,
    Col,
    Radio,
    Typography,
} from 'antd';
import { Globe, Building2 } from 'lucide-react';
import ImgCrop from 'antd-img-crop';
import ReactDropzone from "react-dropzone";
import { connect } from 'react-redux';
import { requestServerPost, selectBrand, selectPage } from '../../actions';

import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import PopupManager from '../../managers/PopupManager';
import path from 'path';
import MediaPreviewPopup from './MediaPreviewPopup';

const { Option } = Select;

const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
};


function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
        onSuccess("ok");
    }, 0);
};

class CreateBrandPage extends Component {
    constructor(props) {
        super(props);
        const { data = null } = props;

        const brandName = data ? data.BrandName : ""
        const sharingMode = data ? String(data.ContentSharingMode || 1) : '1'

        this.mediaPreviewPopupRef = React.createRef();
        if (!data || !data.BrandLogo || data.BrandLogo === "") {
            this.state = {
                brandname: brandName, contentsharingmode: sharingMode, fileList: [], files: [], data: data
            };

            return
        }
        data.BrandLogo = data.BrandLogo
        const logoName = path.basename(data.BrandLogo)
        this.state = {
            brandname: brandName, contentsharingmode: sharingMode, fileList: [{
                uid: '-1',
                name: logoName,
                status: 'done',
                url: data.BrandLogo,
            }], files: [], data: data
        };

    }


    dataURLtoFile = (dataurl, filename) => {

        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    normFile = e => {
        // console.log('Upload event:', e);
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    // beforeUpload = file => {
    //     this.onPreview(file);
    //     return false
    // }

    // onChange = e => {
    //     this.setState({ fileList: e.target.files })
    // }
    onChange = (info) => {
        const { fileList: newFileList, file: newFile } = info

        if (info.file.status === "done") {
            // console.log(JSON.stringify(info.file))
            this.setState({ fileList: newFileList, files: [info.file] })
        }
        else
            this.setState({ fileList: newFileList });
    };

    // onChange = (info) => {
    //     const { fileList: newFileList } = info
    //     console.log("onChange " + JSON.stringify(info))

    //     if (info.file.status === 'uploading') {
    //         return;
    //     }
    //     if (info.file.status === 'done') {
    //         // Get this url from response in real world.
    //         // getBase64(info.file.originFileObj, imageUrl =>
    //         //   this.setState({
    //         //     imageUrl,
    //         //     loading: false,
    //         //   }),
    //         // );

    //     }

    //     // const fileArr = newFileList.map((fileObj) => {
    //     //     const { thumbUrl, name } = fileObj
    //     //     return this.dataURLtoFile(thumbUrl, name)
    //     // })
    //     // this.setState({ fileList: fileArr });
    // };


    // onChange = (e) => {



    //     console.log("onChange " + JSON.stringify(e.target.files[0]))
    //     this.setState({ fileList: e.target.files });
    // };

    // onPreviewDrop = (files) => {
    //     this.setState({
    //         fileList: this.state.fileList.concat(files),
    //     });
    // }



    // getBase64 = (file) => {
    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.readAsDataURL(file);
    //         reader.onload = () => resolve(reader.result);
    //         reader.onerror = error => reject(error);
    //     });
    // }


    onPreview = async file => {
        // console.log("onPreview" + JSON.stringify(file))

        // if (file && this.mediaPreviewPopupRef.current) {
        //     const preview = await getBase64(file.originFileObj);

        //     this.mediaPreviewPopupRef.current.previewMedia(preview);
        // }

        // let src = file.url;
        // if (!src) {
        //     src = await new Promise(resolve => {
        //         const reader = new FileReader();
        //         reader.readAsDataURL(file);
        //         reader.onload = () => resolve(reader.result);
        //     });
        // }
        // console.log("add file")
        // const image = new Image();
        // image.src = src;
        // const imgWindow = window.open(src);
        // this.setState({
        //     files: [file.originFileObj], fileList: [{
        //         uid: '-1',
        //         name: file.name,
        //         status: 'done',
        //         url: src,
        //     }],
        // })
        // imgWindow.document.write(image.outerHTML);

    };

    // onPreview = async file => {
    //     console.log("onPreview")
    //     let src = file.url;
    //     if (!src) {
    //         src = await new Promise(resolve => {
    //             const reader = new FileReader();
    //             reader.readAsDataURL(file.originFileObj);
    //             reader.onload = () => resolve(reader.result);
    //         });
    //     }
    //     console.log("add file")
    //     const image = new Image();
    //     image.src = src;
    //     const imgWindow = window.open(src);
    //     this.setState({ files: [file.originFileObj] })
    //     imgWindow.document.write(image.outerHTML);
    // };

    onFinish = values => {
        const { requestServerPost, usertoken, data = null } = this.props;
        var params = new FormData();



        if (!data) {
            params.append("brandname", values.brandname);
            params.append("contentsharingmode", this.state.contentsharingmode || '1');
            if (this.state.fileList && this.state.fileList.length > 0) {
                for (var index in this.state.fileList) {
                    // console.log("finish " + JSON.stringify(this.state.fileList[index]))
                    params.append('logo[]', this.state.files[index].originFileObj);
                }
            }
            else {
                // console.log("no files " + JSON.stringify(this.state.files))
            }
            requestServerPost("create_brand", params, {}, (response) => {
                PopupManager.closePopup();
            }, usertoken);
        }
        else {
            params.append("brandid", data.BrandID);
            params.append("brandname", values.brandname);
            params.append("contentsharingmode", this.state.contentsharingmode || '1');

            if (this.state.fileList && this.state.fileList.length > 0 && this.state.fileList[0].uid !== "-1") {
                for (var index in this.state.fileList) {
                    params.append('logo[]', this.state.fileList[index].originFileObj);
                }
            }
            else {
                // console.log("no files " + JSON.stringify(this.state.files))
            }
            requestServerPost("update_brand", params, {}, (response) => {
                PopupManager.closePopup();
            }, usertoken);
        }
    };

    render() {
        const { data = null } = this.props;

        return (
            <div className="popupcontentcontainer" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                {/* Header: Title + Illustration side-by-side */}
                <Row style={{ width: "100%", padding: "32px 40px 0 40px" }} align="middle">
                    <Col span={14}>
                        <div style={{ fontSize: 32, fontWeight: 500, lineHeight: "38px" }}>
                            {data ? "Edit Brand Information" : "Let's Create a New Brand"}
                        </div>
                    </Col>
                </Row>

                {/* Form body */}
                <div style={{ padding: "16px 40px 32px 40px", flex: 1 }}>
                    <Form
                        name="validate_other"
                        {...formItemLayout}
                        key={data ? `${data.BrandID + "_form_createbrand"}` : "form_createbrand"}
                        onFinish={this.onFinish}
                        initialValues={{
                            ['brandname']: this.state.brandname,
                        }}
                    >
                        {/* Brand Name + Logo Upload - inline */}
                        <Row gutter={24} align="top">
                            <Col span={12}>
                                <Form.Item
                                    name="brandname"
                                    key={data ? `${data.BrandID + "_form_createbrand_name_item"}` : "form_createbrand_name_item"}
                                    label="Brand Name"
                                    rules={[{ required: true, message: 'Please input brand name!' }]}
                                    labelCol={{ span: 24 }}
                                    style={{ marginBottom: 16 }}
                                >
                                    <Input placeholder="Brand Name *"
                                        key={data ? `${data.BrandID + "_form_createbrand_name"}` : "form_createbrand_name"} onChange={(e) => {
                                            this.setState({ brandname: e.target.value })
                                        }} />
                                </Form.Item>
                            </Col>
                            <Col span={7}>
                                <Form.Item label="Brand Logo" labelCol={{ span: 24 }} style={{ marginBottom: 16 }}>
                                    <Form.Item name="logos" valuePropName="fileList"
                                        getValueFromEvent={this.state.fileList}
                                        key={data ? `${data.BrandID + "_form_createbrand_img"}` : "form_createbran_img"} noStyle>
                                        <ImgCrop rotate>
                                            <Upload
                                                listType="picture-card"
                                                fileList={this.state.fileList}
                                                onChange={this.onChange}
                                                customRequest={dummyRequest}
                                                multiple={false}
                                                onPreview={this.onPreview}
                                            >
                                                {this.state.fileList.length < 1 && (
                                                    <div><img style={{ width: "40px", height: "30px" }} src="/cms/assets/svgs/icons/image_icon.svg" alt="upload" /><div style={{ fontSize: 12, marginTop: 4 }}>Upload Logo</div></div>
                                                )}
                                            </Upload>
                                        </ImgCrop>
                                    </Form.Item>
                                </Form.Item>
                            </Col>
                            <Col span={5} style={{ display: "flex", justifyContent: "center" }}>
                                <img style={{ width: "120%", maxHeight: "200px", objectFit: "contain" }} src="/cms/assets/svgs/decorations/decorate_createbrand.svg" alt="brand decoration" />
                            </Col>
                        </Row>

                        {/* Content Sharing Mode - side-by-side cards */}
                        <Form.Item
                            label="Content Sharing Mode"
                            key={data ? `${data.BrandID + "_form_createbrand_mode_item"}` : "form_createbrand_mode_item"}
                            labelCol={{ span: 24 }}
                            style={{ marginBottom: 16 }}
                        >
                            <Radio.Group
                                value={this.state.contentsharingmode}
                                onChange={(e) => this.setState({ contentsharingmode: e.target.value })}
                                style={{ width: '100%', display: 'flex', gap: '12px' }}
                            >
                                <div style={{
                                    flex: 1, display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '14px',
                                    border: `1.5px solid ${this.state.contentsharingmode === '1' ? '#3b82f6' : '#e2e8f0'}`,
                                    borderRadius: '8px', cursor: 'pointer',
                                    background: this.state.contentsharingmode === '1' ? '#eff6ff' : '#ffffff',
                                    transition: 'all 0.2s',
                                }} onClick={() => { console.log("this.state.contentsharingmode", this.state.contentsharingmode); this.setState({ contentsharingmode: '1' }) }}>
                                    <div style={{ paddingTop: '2px' }}>
                                        <Radio value="1" style={{ marginRight: 0 }} />
                                    </div>
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                                            <Globe size={16} color={this.state.contentsharingmode === '1' ? '#3b82f6' : '#64748b'} />
                                            <Typography.Text strong style={{ fontSize: '14px' }}>Brand-wide Content (Legacy)</Typography.Text>
                                        </div>
                                        <Typography.Text type="secondary" style={{ fontSize: '12px', lineHeight: 1.4, display: 'block' }}>
                                            Playlists and media created while in this mode are shared across the brand, accessible by every branch.
                                        </Typography.Text>
                                    </div>
                                </div>

                                <div style={{
                                    flex: 1, display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '14px',
                                    border: `1.5px solid ${this.state.contentsharingmode === '2' ? '#3b82f6' : '#e2e8f0'}`,
                                    borderRadius: '8px', cursor: 'pointer',
                                    background: this.state.contentsharingmode === '2' ? '#eff6ff' : '#ffffff',
                                    transition: 'all 0.2s',
                                }} onClick={() => { console.log("this.state.contentsharingmode", this.state.contentsharingmode); this.setState({ contentsharingmode: '2' }) }}>
                                    <div style={{ paddingTop: '2px' }}>
                                        <Radio value="2" style={{ marginRight: 0 }} />
                                    </div>
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                                            <Building2 size={16} color={this.state.contentsharingmode === '2' ? '#3b82f6' : '#64748b'} />
                                            <Typography.Text strong style={{ fontSize: '14px' }}>Branch-Scoped Content</Typography.Text>
                                        </div>
                                        <Typography.Text type="secondary" style={{ fontSize: '12px', lineHeight: 1.4, display: 'block' }}>
                                            Brand-level content can target specific branches. Content created inside a branch stays private to that branch.
                                        </Typography.Text>
                                    </div>
                                </div>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item style={{ marginTop: "20px", marginBottom: 0 }}>
                            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
                                {data ? "Update" : "Create"}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>

                <MediaPreviewPopup ref={this.mediaPreviewPopupRef}></MediaPreviewPopup>
            </div>
        );
    }
}

const Styles = {

}


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectBrandData: state.selectBrandData };
}

export default connect(mapStateToProps, { requestServerPost, selectPage })(CreateBrandPage);
